import Main from './Main'
import Lista from './components/CadastroNotificacaoTelegramaLista'
import Novo from './components/NovoCadastroNotificacaoTelegrama'

export default [
  {
    path: 'cadastro-notificacao-telegrama',
    name: 'roubo-furto.cadastro-notificacao-telegrama',
    component: Main,
    redirect: { name: 'roubo-furto.cadastro-notificacao-telegrama.list' },
    children: [
      {
        path: '/',
        name: 'roubo-furto.cadastro-notificacao-telegrama.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'roubo-furto.cadastro-notificacao-telegrama.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'roubo-furto.cadastro-notificacao-telegrama.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/roubo-furto/cadastro-notificacao-telegrama/routes.js